import Grid from "@mui/material/Unstable_Grid2";
import React, { useCallback } from "react";
import { Button, Box, Link, Modal } from "@mui/material";
import "../../OrganisationSettings/Currencies/Currencies.scss";
import { useNavigate } from "react-router-dom";

import UGTable from "../../../../../../Supporting files/UGTable/UGTable";
// import AddCurrency from "./AddCurrency";

const Users = () => {
  const [addcurrency, setAddCurrency] = React.useState(false);
  const [exchangeRate, setExchangeRate] = React.useState(true);
  const [exchangeRateConfrm, setExchangeRateConfrm] = React.useState(false);
  const [deleteStatus, setDeleteStatus] = React.useState(false);
  const navigate = useNavigate();

  //Table Data
  const [columns, setColumns] = React.useState([
    {
      field: "userid",
      headerName: "User ID",
      width: 200,
      check_status: true,
    },
    {
      field: "email",
      headerName: "Email",
      width: 300,

      check_status: true,
    },
    {
      field: "fullname",
      headerName: "Full Name",
      width: 250,
      check_status: true,
      renderCell: (ValueFormatterParams: any) => {
        const { row } = ValueFormatterParams;
        return (
          <p
            style={{
              cursor: "pointer",
              fontWeight: "400",
              color: "#2166AA",
              textDecoration: "none",
            }}
            onClick={() => {
              navigate("/EditCreateUSer");
            }}
          >
            Vikas Saini
          </p>
        );
      },
    },
    {
      field: "role",
      headerName: "Role",
      width: 300,
      check_status: true,
    },
    {
      field: "department",
      headerName: "Department",
      width: 300,
      check_status: true,
    },
    {
      field: "creationdate",
      headerName: "Creation Date",
      width: 200,
      check_status: true,
    },
    {
      field: "creationtime",
      headerName: "Creation Time",
      width: 200,
      check_status: true,
    },
  ]);
  const rows = [
    {
      id: 0,
      userid: "EV001",
      email: "Vikas.saini@evervent.in",
      fullname: "Vikas Saini",
      role: "Ass. Frontend Developer",
      department: "Design",
      creationdate: "22 - Mar - 2023",
      creationtime: "12:00 hrs",
    },
    {
      id: 1,
      userid: "EV002",
      email: "Umesh.gemini@evervent.in",
      fullname: "Umesh Gemini",
      role: "App Developer",
      department: "Engineer",
      creationdate: "22 - Mar - 2023",
      creationtime: "12:00 hrs",
    },
    {
      id: 2,
      userid: "EV003",
      email: "Kartike.Kakkar@evervent.in",
      fullname: "Kartike Kakkar",
      role: "Ass. Frontend Developer",
      department: "Design",
      creationdate: "22 - Mar - 2023",
      creationtime: "12:00 hrs",
    },
  ];

  const updateMasterState = (attrName: any, value: any) => {
    attrName(value);
    if (attrName === setExchangeRate && value === false) {
      setExchangeRateConfrm(true);
    }
  };
  return (
    <Grid container spacing={2} className="currunciesWrapper">
      <Grid xs={4}>
        <h3 className="mb-0">Users</h3>
      </Grid>

      <Grid xs={8} className="text-right">
        <div className="buttons">
          <Link
            underline="none"
            className="greenBtn addfile"
            onClick={() => {
              navigate("/CreateUsers");
            }}
          >
            Create
          </Link>
          <Link
            underline="none"
            className="blueBtn edit"
            onClick={() => {
              navigate("/EditCreateUSer");
            }}
          >
            Edit
          </Link>
          <Link
            underline="none"
            className="redBtn delete"
            onClick={() => {
              setDeleteStatus(true);
            }}
          >
            Remove
          </Link>
        </div>
      </Grid>
      <Grid xs={12}>
        <div style={{ height: 400 }}>
          <UGTable
            header_data={columns}
            data={rows}
            value_update={updateMasterState}
            attrName={"UGTable"}
          />
        </div>
      </Grid>
      <Modal open={deleteStatus} className="modalWrapper">
        <Box className="modalInner">
          <Grid container spacing={1}>
            <Grid xs={12}>
              <Link
                className="close-button"
                onClick={() => {
                  setDeleteStatus(false);
                }}
              />
              <h5 className="popup-heading">Are you sure ?</h5>
            </Grid>
            <Grid xs={12}>
              <Link className="md-link" underline="none">
                You are want to delete 5 Users.
              </Link>
            </Grid>
            <Grid xs={12} className="ctaBtn" textAlign={"center"}>
              <Button variant="contained" className="submitBtn">
                Yes, Delete
              </Button>
            </Grid>
          </Grid>
        </Box>
      </Modal>
    </Grid>
  );
};

export default Users;
